'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';
import Slider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import useBreakpoint from '@/hooks/useBreakpoint';
import { Photo } from '@/types/Gallery';

const GallerySlider = ({ photos }: { photos: Photo[] }) => {
  const isLg = useBreakpoint('lg');
  const [showSlider, setShowSlider] = useState(false);

  const sliderSettings: Settings = {
    className: '',
    centerMode: true,
    infinite: true,
    centerPadding: '32px',
    slidesToShow: isLg ? 4 : 2,
    slidesToScroll: 1,
    speed: 300,
    dots: true,
    arrows: false,
  };

  useEffect(() => {
    setShowSlider(true);
  }, []);

  if (!showSlider) return null;

  return (
    <div>
      <Slider {...sliderSettings}>
        {photos.map((photo) => {
          return (
            <div key={photo.id} className="px-4">
              <Image
                src={photo.path}
                width={96}
                height={96}
                className="h-24 w-24 object-cover"
                alt={`Bild på en klippning`}
              />
            </div>
          );
        })}
      </Slider>
    </div>
  );
};
export default GallerySlider;
